import Vue from 'vue';
import Vuex from 'vuex';
import developer from './developer';
import promo from './promo';
import bank from './bank';
import residential from './residential';
import advantageObject from './advantageObject';
import advantageCompany from './advantageCompany';
import items from './items';
import user from './user';
import repair from './repair';
import post from './post';
import digital from './digital';
import districts from './districts';
import city from './city';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        developer,
        promo,
        bank,
        advantageObject,
        advantageCompany,
        residential,
        items,
        user,
        repair,
        post,
        digital,
        districts,
        city,
    },
});
